// ========================
// CarClass mappings
// ========================

export enum CarClass {
  TERCEIRO = 'TERCEIRO',
  ASSOCIADO = 'ASSOCIADO',
  MOBI = 'MOBI',
  CARROS_EXTERNOS = 'CARROS_EXTERNOS',
  CARROS_ATUAL = 'CARROS_ATUAL',
  MOTO = 'MOTO',
  AIRO_CLUBE = 'AIRO_CLUBE',
  PERDA_TOTAL = 'PERDA_TOTAL',
  DIRETORIA = 'DIRETORIA',
}

export const CarClassMap: Record<CarClass, string> = {
  [CarClass.TERCEIRO]: 'Terceiro',
  [CarClass.ASSOCIADO]: 'Associado',
  [CarClass.MOBI]: 'Mobi',
  [CarClass.CARROS_EXTERNOS]: 'Carros Externos',
  [CarClass.CARROS_ATUAL]: 'Carros Atual',
  [CarClass.MOTO]: 'Moto',
  [CarClass.AIRO_CLUBE]: 'Airo Clube',
  [CarClass.PERDA_TOTAL]: 'Perda Total',
  [CarClass.DIRETORIA]: 'Diretoria',
};

export const CarClassOptions: CarClass[] = Object.keys(CarClassMap) as CarClass[];

export const getCarClassKeyFromLabel = (label: string): CarClass =>
  (Object.entries(CarClassMap).find(([, value]) => value === label)?.[0] as CarClass) || label;

// ========================
// ApprovalStatus mappings
// ========================

export const ApprovalStatusMap: Record<string, string> = {
  PENDING: 'Pendente',
  APPROVED: 'Aprovado',
  REJECTED: 'Rejeitado',
};

export const ApprovalStatusOptions: string[] = Object.keys(ApprovalStatusMap);

// ========================
// DamageType mappings
// ========================

export enum DamageType {
  PEQUENO = 'PEQUENO',
  MEDIO = 'MEDIO',
  GRANDE = 'GRANDE',
}

export const DamageTypeMap: Record<DamageType, string> = {
  [DamageType.PEQUENO]: 'Pequeno',
  [DamageType.MEDIO]: 'Médio',
  [DamageType.GRANDE]: 'Grande',
};

export const DamageTypeOptions: DamageType[] = Object.keys(DamageTypeMap) as DamageType[];

export const getDamageTypeKeyFromLabel = (label: string): DamageType =>
  (Object.entries(DamageTypeMap).find(([, value]) => value === label)?.[0] as DamageType) || label;

// ========================
// WaitingReason mappings
// ========================

export enum WaitingReason {
  JURIDICO = "JURIDICO",
  COTA_PARTICIPACAO = "COTA_PARTICIPACAO",
  SINDICANCIA = "SINDICANCIA",
  DIRETORIA = "DIRETORIA",
  DOCUMENTACAO = "DOCUMENTACAO",
  INADIMPLENTE = "INADIMPLENTE",
}

export const WaitingReasonMap: Record<WaitingReason, string> = {
  [WaitingReason.JURIDICO]: 'Jurídico',
  [WaitingReason.COTA_PARTICIPACAO]: 'Cota de Participação',
  [WaitingReason.SINDICANCIA]: 'Sindicância',
  [WaitingReason.DIRETORIA]: 'Diretoria',
  [WaitingReason.DOCUMENTACAO]: 'Documentação',
  [WaitingReason.INADIMPLENTE]: 'Inadimplente',
};

export const WaitingReasonOptions: WaitingReason[] = Object.keys(WaitingReasonMap) as WaitingReason[];

export const getWaitingReasonKeyFromLabel = (label: string): WaitingReason =>
  (Object.entries(WaitingReasonMap).find(([, value]) => value === label)?.[0] as WaitingReason) || label;
